import { Component, OnInit, SecurityContext } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {AuthenticationService } from 'src/app/shared/services/authentication.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as validator from 'validator';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  addUserForm: FormGroup;
  imgPreview: string | ArrayBuffer;
  userData = new FormData();
  imageError:any;

  constructor(private formBuilder: FormBuilder, private auth: AuthenticationService , private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.addUserForm = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
      lastName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
      // email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      // email: ['', [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)]],
      // email: ['', [
      //   Validators.required,
      //   Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/)
      // ]],
      email: ['', [Validators.required, this.emailValidator]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(10), Validators.maxLength(15)]], // Numeric only, 10 to 15 digits
      address: ['', Validators.required],
      zip: ['', [Validators.required, Validators.pattern('^[0-9]{6}(?:-[0-9]{4})?$')]], // 5 digits or 5+4 digits
      state: ['', Validators.required],
      position: ['', Validators.required],
      profilePic: [null, Validators.required]
    });
  }

  emailValidator(control: any) {
    if (control.value && !validator.isEmail(control.value, { allow_utf8_local_part: false })) {
      return { invalidEmail: true };
    }
    return null;
  }

  
  
  onlyAlphabet(event: KeyboardEvent): void {
    const charCode = event.which || event.keyCode;
    if (charCode < 65 || charCode > 90 && charCode < 97 || charCode > 122) {
      event.preventDefault();
    }
  }

  filterNameInput(event: any): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^a-zA-Z]/g, '');
  }

  // preventPaste(event: ClipboardEvent): void {
  //   event.preventDefault();
  // }

  // preventDrop(event: DragEvent): void {
  //   event.preventDefault();
  // }
  onlyNumbers(event: KeyboardEvent): void {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  filterPhoneNumber(event: any): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }
 // Filter zip code to allow only numbers and dash
 filterZipCode(event: any): void {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^0-9-]/g, '');
}
  preventPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  preventDrop(event: DragEvent): void {
    event.preventDefault();
  }

  fileChangeEvent(fileInput: any) {
    this.imageError = null;
    const file = fileInput.target.files[0];
    if (file) {
      const max_size = 20971520; // 20MB
      const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
      if (file.size > max_size) {
        this.imageError = 'Maximum size allowed is 20MB';
      } else if (!allowed_types.includes(file.type)) {
        this.imageError = 'Only images are allowed (JPG | PNG)';
      } else {
        this.userData.append('profilePic', file, file.name);
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imgPreview = this.sanitizeImage(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
  }
  

  // fileChangeEvent(fileInput: any) {
  //   this.imageError = null;
  //   if (fileInput.target.files && fileInput.target.files[0]) {
  //       // Size Filter Bytes
  //       const max_size = 20971520;
  //       const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
  //       let cardImageBase64:any;
  //       let isImageSaved:any;

  //       if (fileInput.target.files[0].size > max_size) {
  //           this.imageError = 'Maximum size allowed is ' + max_size / 1000 + 'Mb';
  //           // return false;
  //       }
  //       else if (!allowed_types.includes(fileInput.target.files[0].type)) {
  //           this.imageError = 'Only Images are allowed ( JPG | PNG )';
  //           // return false;
  //       }
  //       else
  //       {
  //         console.log(fileInput.target.files)
  //         let files: FileList = fileInput.target.files;
  //         let file : File = files[0];
  //         this.userData.append('profilePic', files[0], files[0].name);
  //         const reader = new FileReader();
  //         reader.onload = (e: any) => {
  //           const image = new Image();
  //           image.src = e.target.result;
  //           image.onload = (rs:any) => {              
  //             const imgBase64Path = e.target.result;
  //             this.imgPreview = imgBase64Path;
  //           };
  //         };
  //       }
  //   }
  // }
  
  // fileChangeEvent(fileInput: any) {
  //   this.imageError = null;
  //   const file = fileInput.target.files[0];
  //   if (file) {
  //     const max_size = 20971520; // 20MB
  //     const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
  //     if (file.size > max_size) {
  //       this.imageError = 'Maximum size allowed is 20MB';
  //     } else if (!allowed_types.includes(file.type)) {
  //       this.imageError = 'Only images are allowed (JPG | PNG)';
  //     } else {
  //       this.addUserForm.patchValue({ profilePic: file });
  //       this.userData.append('profilePic', file, file.name);
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         this.imgPreview = this.sanitizeImage(e.target.result);
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   }
  // }
  sanitizeImage(image: string): string {
    return this.sanitizer.sanitize(SecurityContext.URL, image) || '';
  }

  addUser(): void {
    if (this.addUserForm.valid) {
      this.userData.append('firstName', this.addUserForm.get('firstName').value);
      this.userData.append('lastName', this.addUserForm.get('lastName').value);
      this.userData.append('email', this.addUserForm.get('email').value);
      this.userData.append('phone', this.addUserForm.get('phone').value);
      this.userData.append('position', this.addUserForm.get('position').value);
      this.userData.append('address', this.addUserForm.get('address').value);
      this.userData.append('zip', this.addUserForm.get('zip').value);
      this.userData.append('state', this.addUserForm.get('state').value);

      this.auth.addUser(this.userData).subscribe(
        (res: any) => {
            console.log(res);
            this.addUserForm.reset();
            this.imgPreview = null;
        },
        (err: any) => {
            console.log(err);
        }
    );
    }
  }
  resetForm(): void {
    this.addUserForm.reset(); // Reset the form fields
    this.imgPreview = null; // Clear the image preview
  }
}
